<template>
    <div id="app" :style="{height: windowHeight + 'px'}">
        <LoadingBar
            ref="LoadingBar"
        >
        </LoadingBar>
        <app-header/>
        <router-view></router-view>
    </div>
</template>

<script>
import Header from '@/components/header.vue'
import LoadingBar from '@/components/LoadingBar.vue'

export default {
    name: 'app',
    data() {
        return {
            windowHeight: window.innerHeight,
        };
    },
    components: {
        'LoadingBar': LoadingBar,
        'app-header': Header
    },
    methods: {
        handleWindowResize(event) {
            this.windowHeight = event.currentTarget.innerHeight;
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleWindowResize);

        // start LoadingBar...
        this.$refs.LoadingBar.trigger()

        setTimeout(()=> {
            this.$refs.LoadingBar.done()
        }, 2000)
    }
}

</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    body {
      background-color: rgb(0,66,111);
      margin: 0;
    }

    .body-home {
      background-color: rgb(0,66,111);
    }

    .body-other {
      background-color: #fff;
    }
    .body-game-intro {
      overflow-y: auto;
    }
.page-fix {
    overflow: hidden;
}
</style>
